module.exports = __webpack_public_path__ + "img/inds.717200b2.png";